import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Search from "@mui/icons-material/Search";
import FilterList from "@mui/icons-material/FilterList";

export type TableFilterOptions = {
  showHidden?: boolean;
  onShowHiddenChange?: (show: boolean) => void;
};

type UserTableToolbarProps = {
  numSelected: number;
  filter: string;
  onFilter: any;
  filterOptions?: TableFilterOptions;
};
export default function CustomTableToolbar({
  numSelected,
  filter,
  onFilter,
  filterOptions,
}: UserTableToolbarProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const filterOpen = Boolean(anchorEl);
  const canToggleHidden = typeof filterOptions?.onShowHiddenChange === "function";

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 !important",
        margin: 0,
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <OutlinedInput
          value={filter}
          onChange={onFilter}
          placeholder="Search..."
          sx={{ height: 40 }}
          inputProps={{ style: { margin: 0 } }}
          startAdornment={
            <InputAdornment position="start">
              <Search sx={{ color: "text.disabled", width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      <Tooltip title="Filter list">
        <IconButton
          color={filterOptions?.showHidden ? "primary" : "default"}
          onClick={(event) => {
            if (!canToggleHidden) return;
            setAnchorEl(event.currentTarget);
          }}
          aria-label="Filter list"
          aria-haspopup="true"
          aria-expanded={filterOpen ? "true" : undefined}
        >
          <FilterList />
        </IconButton>
      </Tooltip>
      {canToggleHidden && (
        <Menu
          anchorEl={anchorEl}
          open={filterOpen}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem sx={{ py: 0.5 }}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={Boolean(filterOptions?.showHidden)}
                  onChange={(event) =>
                    filterOptions?.onShowHiddenChange?.(event.target.checked)
                  }
                />
              }
              label="Show hidden"
            />
          </MenuItem>
        </Menu>
      )}
    </Toolbar>
  );
}
